import { combineReducers } from 'redux';
import financialReducer from './financialReducer';
import homeReducer from './homeReducer';
import inventoryReducer from './inventoryReducer';
import orderReducer from './orderReducer';
import productReducer from './productReducer';
import promotionReducer from './promotionReducer';
import customerReducer from './customerReducer';
import categoryReducer from './categoryReducer';
import staffReducer from './staffReducer';

const rootReducers = combineReducers({
  homeReducer,
  financialReducer,
  productReducer,
  inventoryReducer,
  orderReducer,
  promotionReducer,
  customerReducer,
  categoryReducer,
  staffReducer
});

export default rootReducers;
